import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=7dda32c2&lang=pug"
import script from "./Buffer.vue?vue&type=script&lang=js"
export * from "./Buffer.vue?vue&type=script&lang=js"
import style0 from "./Buffer.vue?vue&type=style&index=0&id=7dda32c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports